module.exports = __webpack_public_path__ + "img/instagramestory8.ae52cecd.jpg";